import request from '../utils/request';


/**
 * 通过areaId换 regionId
 * @param param
 * @returns {*}
 */
export const selectCourseTypeRegion = (param) => {
    return request({
        url: '/sys/courseTypeDict/selectRegion',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 查询签课类型
 * @param param
 * @returns {*}
 */
export const selectCourseType = (param) => {
    return request({
        url: '/sys/courseTypeDict/selectCourseType',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
/**
 * 新增 消课类型
 * @param param
 * @returns {*}
 */
export const insertCourseType = (param) => {
    return request({
        url: '/sys/courseTypeDict/insertCourseType',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
/**
 * 修改消课类型
 * @param param
 * @returns {*}
 */
export const updateCourseType = (param) => {
    return request({
        url: '/sys/courseTypeDict/updateCourseType',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};

/**
 * 修改该城市的消课类型关联的启用状态
 * @param param
 * @returns {*}
 */
export const updateCourseTypeState = (param) => {
    return request({
        url: '/sys/courseTypeDict/updateState',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
